import React, { Component } from 'react';
import { shape, string } from 'prop-types';
import { connect } from 'react-redux';

import ReadViews from './views';


class Read extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAffordancesOpen: false
    };
  }

  openAffordances = () => {
    this.setState({
      isAffordancesOpen: true
    });
  }

  componentDidUpdate(prevProps) {
    const { isAffordancesOpen } = this.props;
  
    if (isAffordancesOpen !== prevProps.isAffordancesOpen) {
      this.setState({ isAffordancesOpen });
    }
  }

  render() {
    const { selectedHighlight } = this.props;
    const { isAffordancesOpen } = this.state;

    const headerStyles = {
      'borderBottom': `1px solid ${selectedHighlight.darkColor}`
    };

    const viewProps = {
      headerStyles,
      isAffordancesOpen,
      openAffordances: this.openAffordances,
      selectedHighlight
    };

    return <ReadViews { ...viewProps } />;
  }
}

Read.propTypes = {
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    id: string,
    noteText: string,
    lastModifiedAt: string
  })
};


function mapStateToProps(state) {
  const { selectedHighlight } = state;

  return {
    selectedHighlight
  };
}

export default connect(mapStateToProps)(Read);
